@if ({ uploadedFiles: (uploadedFiles$ | async)! }; as obj) {
  <div>
    @if (obj.uploadedFiles.length) {
      <div style="max-height: 25vh" [class]="classNames">
        @if (!titleLess) {
          <p>Uploaded files</p>
        }
        @for (file of obj.uploadedFiles; track file; let i = $index) {
          <div
            class="upload-file-item flex items-center justify-between py-3"
            [ngClass]="{ 'border-t border-aux-gray-dark': i !== 0 }"
          >
            <p class="break-words" style="max-width: 60%">{{ file.fileName }}</p>
            <div class="flex-justify-between space-x-8">
              <aux-icon
                name="Download"
                class="cursor-pointer text-aux-blue"
                (click)="onDownloadFile(file)"
              />
              <aux-icon
                name="Trash"
                class="cursor-pointer text-aux-error"
                [ngClass]="{ '!cursor-not-allowed opacity-70': disabled }"
                (click)="onRemoveFile(file)"
              />
            </div>
          </div>
        }
      </div>
    }
  </div>
}
